import { Button, ButtonVariants } from '../../../Button';
import { Box, HStack } from '../../../Core';
import { Icon } from '../../../Icons/Icon';
import { IconName } from '../../../Icons/IconNames';
import { Text } from '../../../Text';
import type { WorkflowSummarySection } from './types';
import { WorkflowDrawerLayout } from './WorkflowDrawerLayout';
import { WorkflowSummaryCard } from './WorkflowSummaryCard';

export function WorkflowSuccessView({
  message,
  sections,
  onCopyDetails,
  onDone,
}: {
  message: string;
  sections: WorkflowSummarySection[];
  onCopyDetails: () => void;
  onDone: () => void;
}) {
  return (
    <WorkflowDrawerLayout>
      <Box flex="1" minHeight={0} overflowY="auto">
        <Box px="spacing32" py="spacing32" display="flex" flexDirection="column" alignItems="center">
          <Box
            mb="spacing16"
            w="72px"
            h="72px"
            borderRadius="100%"
            background="backgroundPositiveMuted"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Icon icon={IconName.Check} size={28} color="colorTextPositive" />
          </Box>
          <Text fontSize="18px" fontWeight="500" mb="spacing24" textAlign="center">
            {message}
          </Text>
          <Box w="100%" maxWidth="520px">
            <WorkflowSummaryCard sections={sections} onCopy={onCopyDetails} />
          </Box>
        </Box>
      </Box>
      <HStack
        flex="none"
        gap="spacing12"
        p="spacing12"
        position="sticky"
        bottom="0"
        zIndex={1}
        borderTop="1px solid"
        borderColor="colors.gray.030"
        background="backgroundDrawer"
      >
        <Button flex="1" variant={ButtonVariants.Primary} onClick={onDone}>
          Done
        </Button>
      </HStack>
    </WorkflowDrawerLayout>
  );
}
